export default __webpack_public_path__ + "static/media/kitchen5-afterB-1024w.7c2b72b9.avif";